import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallHistorySlice = (set, get) => ({
    crmCallHistory: {
        loading: false,
        data: []
    },
    getCrmCallHistory: async (UsrUserID) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallHistory: { ...state.crmCallHistory, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-histories/${UsrUserID}`,
                headers: { token }
            });
            set(state => ({ crmCallHistory: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallHistory: { loading: false, data: [] } }));
        }
    }
});
